// extracted by mini-css-extract-plugin
export const pageContent = "Index-module--pageContent--3gLa5";
export const homePage = "Index-module--homePage--1abAO";
export const mainLinks = "Index-module--mainLinks--1Wckz";
export const disabled = "Index-module--disabled--2mKFU";